import React, { useEffect, useState } from 'react'

export default function StudentFormModal({ initial, onCancel, onSave }){
  const [form, setForm] = useState({
    enrollment: '', name: '', fatherName:'', motherName:'', session:'', course:'', dob:'', remark:''
  })
  const [studentPhoto, setStudentPhoto] = useState(null)
  const [resultFile, setResultFile] = useState(null)
  const [busy, setBusy] = useState(false)
  const [preview, setPreview] = useState(initial?.photoUrl || '')

  useEffect(()=>{
    if (initial){
      setForm({
        enrollment: initial.enrollment || '',
        name: initial.name || '',
        fatherName: initial.fatherName || '',
        motherName: initial.motherName || '',
        session: initial.session || '',
        course: initial.course || '',
        dob: initial.dob || '',
        remark: initial.result?.remark || ''
      })
      setPreview(initial.photoUrl || '')
    }
  }, [initial])

  function change(e){ setForm(f=> ({...f, [e.target.name]: e.target.value})) }

  function onPickPhoto(e){
    const f = e.target.files?.[0]
    setStudentPhoto(f || null)
    if (f){
      const url = URL.createObjectURL(f)
      setPreview(url)
    } else setPreview(initial?.photoUrl || '')
  }

  async function submit(e){
    e.preventDefault()
    setBusy(true)
    try{
      await onSave({ ...form, studentPhoto, resultFile })
    } finally { setBusy(false) }
  }

  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal" onClick={(e)=> e.stopPropagation()}>
        <div className="modal-header">
          <div style={{display:'flex', alignItems:'center', gap:12}}>
            <div className="modal-title">{initial ? 'Edit Student' : 'Add Student'}</div>
            <div className="small" style={{color:'var(--muted)'}}>{initial ? `ID: ${initial.enrollment || '-'}` : ''}</div>
          </div>

          <div className="modal-actions">
            <button className="btn secondary" onClick={onCancel}>Close</button>
            {/* form submit button is here so it's always visible on wider screens */}
            <button className="btn" form="student-form" type="submit" onClick={(e)=>{ /* ensure form submit */ }} disabled={busy}>
              {busy ? 'Saving…' : 'Save'}
            </button>
          </div>
        </div>

        {/* scrollable body */}
        <form id="student-form" onSubmit={submit} className="modal-body" >
          <div>
            <label className="small">Enrollment</label>
            <input className="input" required name="enrollment" value={form.enrollment} onChange={change}/>
          </div>

          <div>
            <label className="small">Name</label>
            <input className="input" required name="name" value={form.name} onChange={change}/>
          </div>

          <div>
            <label className="small">Father Name</label>
            <input className="input" name="fatherName" value={form.fatherName} onChange={change}/>
          </div>

          <div>
            <label className="small">Mother Name</label>
            <input className="input" name="motherName" value={form.motherName} onChange={change}/>
          </div>

          <div>
            <label className="small">Session</label>
            <input className="input" name="session" value={form.session} onChange={change}/>
          </div>

          <div>
            <label className="small">Course</label>
            <input className="input" required name="course" value={form.course} onChange={change}/>
          </div>

          <div>
            <label className="small">DOB</label>
            <input className="input" required type="date" name="dob" value={form.dob} onChange={change}/>
          </div>

          <div>
            <label className="small">Remark</label>
            <input className="input" name="remark" value={form.remark} onChange={change}/>
          </div>


          <div>
            <label className="small">Student Photo</label>
            <input className="file" type="file" accept="image/*" onChange={onPickPhoto}/>
            {preview && (
              <div style={{marginTop:10}}>
                <img src={preview} alt="" style={{width:84, height:84, objectFit:'cover', borderRadius:10, border:'1px solid var(--border)'}}/>
              </div>
            )}
          </div>

          <div>
            <label className="small">Result (PDF)</label>
            <input className="file" type="file" accept="application/pdf" onChange={e=> setResultFile(e.target.files?.[0] || null)}/>
            {initial?.result?.originalName && <div style={{color:'var(--muted)', fontSize:13, marginTop:8}}>Current: {initial.result.originalName}</div>}
          </div>
        </form>

        {/* sticky footer — helpful on mobile so action always visible */}
        <div className="modal-footer" role="toolbar">
          <div style={{flex:1}}></div>
          <button className="btn secondary" onClick={onCancel}>Cancel</button>
          <button className="btn" onClick={(e)=> document.getElementById('student-form').dispatchEvent(new Event('submit', {cancelable:true, bubbles:true}))} disabled={busy}>
            {busy ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  )
}
